import englishStrings from './resourceStrings.json';
import welshStrings from './resourceStrings.cy.json';
import testLanguageStrings from './resourceStrings.vi-VN.json';
const resourceData = {
  'en-us': englishStrings,
  'cy': welshStrings,
  'vi-vn': testLanguageStrings
};

export default resourceData;
